import { OrgRole, SystemRole } from '_/utils/orgUserUtils';

// Org Roles
export const OPS_INCLUDED = [OrgRole.ADMIN, OrgRole.OPS];
export const MEMBER_NOT_INCLUDED = [OrgRole.ADMIN, OrgRole.SCHEMA_ADMIN, OrgRole.OPS];
export const SOURCE_ENGINEER_NOT_INCLUDED = [OrgRole.ADMIN, OrgRole.SCHEMA_ADMIN, OrgRole.MEMBER, OrgRole.OPS];

// System Roles
export const SUPER_ADMIN_ALLOWED = [SystemRole.DEVELOPER, SystemRole.SUPER_ADMIN];
